import _ from 'lodash';
import { createSelector } from 'reselect';

import { getProgramsCategory } from './programsCategory.selectors';

const selectInvestorProductPlanIdentifiers = createSelector(
  getProgramsCategory,
  ({ investorProductPlanIdentifiers }) => investorProductPlanIdentifiers,
);

const selectOrderedInvestorProductPlanIdentifiers = createSelector(
  selectInvestorProductPlanIdentifiers,
  investorProductPlanIdentifiers => _.orderBy(investorProductPlanIdentifiers, 'order'),
);

export const selectInvestorProductPlanIdentifiersOptions = createSelector(
  selectOrderedInvestorProductPlanIdentifiers,
  investorProductPlanIdentifiers =>
    Object.values(investorProductPlanIdentifiers)?.map(({ armPlanText, id }) => ({
      name: armPlanText,
      value: id,
    })),
);
